export enum InspectionModule {
  ARCAD = 1,
  PERREAD = 2,
  STRADAD = 3,
}
